import { Card, CardContent, Typography } from '@mui/material';
import { Svgs } from '../assets/svg';
import { Row, Spacer } from '.';

const PasswordRequirements: React.FC = () => {
  return (
    <Card variant='innerCard' style={{ width: '40%' }}>
      <CardContent className='pad20'>
        <Row>
          <Svgs.DisplayExtraSmallCustomX />
          <Spacer width='xxs' />
          <Typography variant='p14' color='error.main'>
            Must be between 8-32 characters.
          </Typography>
        </Row>
        <Spacer height='xxs' />
        <Row>
          <Svgs.DisplayExtraSmallCustomX />
          <Spacer width='xxs' />
          <Typography variant='p14' color='error.main'>
            Must include one number.
          </Typography>
        </Row>
        <Spacer height='xxs' />
        <Row>
          <Svgs.DisplayExtraSmallCustomX />
          <Spacer width='xxs' />
          <Typography variant='p14' color='error.main'>
            Must include one upper case letter.
          </Typography>
        </Row>
        <Spacer height='xxs' />
        <Row>
          <Svgs.DisplayExtraSmallCustomX />
          <Spacer width='xxs' />
          <Typography variant='p14' color='error.main'>
            Must include one special character.
          </Typography>
        </Row>
      </CardContent>
    </Card>
  );
};

export default PasswordRequirements;
